/*
-------- Activate are-you-sure 
*/

$(function() {
  $('.portal.exam form').areYouSure();
});

/*
-------- previus and next-button 
*/


$(function() {
  $(".portal.exam .btn.next").on('click', function() {
    var nextArea = $(this).closest(".area").next();
    $(".portal.exam .area").hide();
    nextArea.show();
    $(window).scrollTop($('.portal.exam').offset().top);
  });
});

$(function() {
  $(".portal.exam .btn.previous").on('click', function() {
    var nextArea = $(this).closest(".area").prev();
    $(".portal.exam .area").hide();
    nextArea.show();
    $(window).scrollTop($('.portal.exam').offset().top);
  });
});




/*
-------- Submit exam 
*/



$(function() {
  $(".portal.exam form").submit(function(e) {
    
    e.preventDefault(); // avoid to execute the actual submit of the form.
    var buttons = $(this).find(".prev-next .btn");
    var id = $(this).data("entry-id");
    var lang = $(this).data("entry-lang");
    if (lang == "en") {
      var url = "/actions/exam/submit?entry_id=" + id
    } else {
      var url = "/" + lang + "/actions/exam/submit?entry_id=" + id 
    }
    var data = new FormData($(".portal.exam form")[0]);

    $.ajax(url, {    
      url:  url,
      data: data,
      type: 'POST',
      dataType: 'json',
      async: false,
      cache: false,
      contentType: false,
      processData: false,
      success: function(response) {
        $('.content-style-main').html(response);
        $(window).scrollTop(($('.portal.exam').offset().top - 100));
      },
      error: function(response) {
        buttons.prop("disabled",false);
      }
    });
    buttons.prop("disabled",true);
  });
});



/*
-------- Show hide my answer
*/

$(function() {
  $( '.portal.exam' ).on( 'click', '.show-my-answer a', function( event ) {
    var question = $(this).closest(".question");
    question.find(".show-my-answer").hide();
    question.find(".expandable").show();
    return false;
  });
});

$(function() {
  $( '.portal.exam' ).on( 'click', '.hide-my-answer', function( event ) {
    var question = $(this).closest(".question");
    question.find(".show-my-answer").show();
    question.find(".expandable").hide();
    return false;
  });
});

